module.exports = __webpack_public_path__ + "img/60f5.177ab960.jpg";